import React from "react";
import { Link } from "react-router-dom";

const ChiSono = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-beige-light to-sage-light">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/images/chi-sono-hero.jpg')`,
          backgroundPosition: '50% 44%'
          }}
        />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-title font-bold text-white mb-6">
              Chi Sono
            </h1>
            <p className="text-lg md:text-2xl font-body text-white max-w-3xl mx-auto">
              Chef Roberto Cattaneo
            </p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <div 
                className="rounded-3xl shadow-2xl h-[28rem] bg-cover"
                style={{
                  backgroundImage: `url('/images/roberto-chef.jpg')`,
                  backgroundPosition: '50% 15%'
                }}
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-title font-bold text-sage-dark mb-6">
                La Mia Storia
              </h2>
              <p className="text-lg font-body text-neutral-600 mb-6 leading-relaxed">
                Ciao! Sono Roberto Cattaneo, un giovane chef e Acquolina è il mio nuovo progetto. 
Ho frequentato la scuola alberghiera con il sogno di aprire un ristorante tutto mio e per questo, fin dai primi anni di studio, ho sentito l’esigenza di mettermi alla prova lavorando sul campo in alcuni locali della bergamasca.
              </p>
              <p className="text-lg font-body text-neutral-600 mb-6 leading-relaxed">
                Nel 2020 avevo in programma di partire per una stagione lavorativa di alto livello a Formentera, ma a causa dell’emergenza sanitaria ho dovuto rivedere i miei piani. Ma, come spesso accade, dalle difficoltà nascono opportunità e dal 2020 al 2025 mi sono misurato con esperienze in ristoranti  molto diversi tra loro. 
              </p>
              <p className="text-lg font-body text-neutral-600 mb-8 leading-relaxed">
                Questo mi hanno permesso di acquisire sempre più consapevolezza professionale e decidere di fare il grande passo verso un progetto tutto mio. Ed è qui che nasce Acquolina, prima come pensiero e desiderio e poi come…realtà.
                </p>
              <p className="text-lg font-body text-neutral-600 mb-8 leading-relaxed">
                </p>
              <p className="text-lg font-body text-neutral-600 mb-8 leading-relaxed">
                Benvenuti nel mio mondo, Chef Roberto Cattaneo 
 
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-sage-dark text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-title font-bold mb-6">
            Scopri ACQUOLINA
          </h2>
          <p className="text-xl font-body mb-8 opacity-90">
            Lasciati conquistare dalla passione per la cucina autentica e dalla qualità 
            che contraddistingue ogni mia preparazione.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/gastronomia"
              className="bg-white text-sage-dark hover:bg-beige-light px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
            >
              Gastronomia
            </Link>
            <Link 
              to="/personal-chef"
              className="border-2 border-white hover:bg-white hover:text-sage-dark px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
              onClick={() => window.scrollTo(0, 0)}
            >
              Personal Chef
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChiSono;